import useTranslation from "@babackapp/translations/use-translation";

export default function useGreeting() {
  const t = useTranslation();
  const currentHour = new Date().getHours();
  if (currentHour >= 5 && currentHour < 12) {
    return t("greeting.goodMorning");
  } else if (currentHour >= 12 && currentHour < 18) {
    return t("greeting.goodAfternoon");
  } else {
    return t("greeting.goodEvening");
  }
}
